import React, { useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, useWatch } from "react-hook-form";
import { useFormData } from "../../context";
import PostcodeSearch from '../inputs/PostcodeSearch';
import NavigationStep from './NavigationStep';
import { storePurpose, providePurpose } from "../../utils/Purpose";
import AddressInfo from '../inputs/AddressInfo';
import { areFieldsEqual } from '../../utils/ObjectCompare';
import { env } from '../../env'
export default function AddressInfoStep(props) {

    // Declare state variables using useForm
    const { purposeId, provider, route, nextRoute, prevRoute, isMultiStep } = props
    const { setFormValues, data } = useFormData();
    const { handleSubmit, formState, control, setValue, getValues, reset } = useForm({
        mode: "onSubmit",
        defaultValues: { address: providePurpose('df.ad', purposeId) }
    });
    const { errors } = formState;
    const watchuser = useWatch({ control, name: 'user', defaultValue: providePurpose('df.us', purposeId) });
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    // Declare effects using useEffect
    useEffect(() => {
        if (data.address) {
            reset({ address: data.address });
        }
    }, [data.address, reset]);

    useEffect(() => {
        document.title = 'CPA - Address';

        if (isMultiStep && !watchuser) {
            navigate({ pathname: prevRoute, replace: false, preserveSearch: true, search });
        } 
    }, []);

    // Declare event handlers or other functions
    const onSubmit = (args) => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`AddressInfoStep.onSubmit`);
            console.log(args);
        }

        setFormValues(args);

        if (!data.address || !areFieldsEqual(data.address, args.address, ['line1', 'line2', 'line3', 'city', 'county', 'postcode'])) {
            setFormValues({ addressChange: true });
        }

        storePurpose('df.ad', args.address, purposeId);
        navigate({ pathname: nextRoute, replace: false, preserveSearch: true, search });
    };

    // Render JSX using state variables and other variables
    return (
        <div className="container" style={pathname === route ? {} : { display: 'none' }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                {provider && <PostcodeSearch provider={provider} control={control}  setValue={setValue} />}
                <AddressInfo control={control} errors={errors} />
                <NavigationStep prevRoute={prevRoute} />
            </form>
        </div>
    );
};